/**
 * Martins Tipp auf eine Ja/Nein-Karte des Schmieds an die Karten-Route (server/schmied-karte-route.ts). (20.10.2026, shared/schmied-karte.ts)
 * Gesendet werden nur Kennung und Ja/Nein, mit dem Pflichtkopf der eigenen Seite (wie lib/beleg-anfrage.ts) und der Gerätekennung (Echo-Filter).
 * Antwort: `{ ok: true }` oder ein fester Fehlercode; `null` = Netz oder unlesbare Antwort.
 */
import { GERAET_KOPF } from "../../shared/geraet-kennung.js";
import { EIGENES_GERAET } from "./geraet-kennung.js";
import { KARTE_FEHLER, KARTE_KOPF_WERT, KARTE_PFAD, type KarteAntwort, type KarteFehlerCode } from "../../shared/schmied-karte.js";

export type KarteErgebnis = { ok: true } | { ok: false; error: KarteFehlerCode; antwort?: KarteAntwort };

export async function sendeKarte(kennung: string, antwort: KarteAntwort): Promise<KarteErgebnis | null> {
  try {
    const r = await fetch(KARTE_PFAD, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "X-Vespera-Aktion": KARTE_KOPF_WERT, [GERAET_KOPF]: EIGENES_GERAET },
      body: JSON.stringify({ kennung, antwort }),
    });
    const j = (await r.json().catch(() => null)) as { ok?: unknown; error?: unknown; antwort?: unknown } | null;
    if (!j) return null;
    if (j.ok === true && r.ok) return { ok: true };
    const code = (KARTE_FEHLER as readonly string[]).includes(String(j.error)) ? (j.error as KarteFehlerCode) : "nicht-bereit";
    return { ok: false, error: code, ...(j.antwort === "ja" || j.antwort === "nein" ? { antwort: j.antwort } : {}) };
  } catch {
    return null;
  }
}
